import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './kirin/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppLayoutComponent,
                children: [
                    { path: '', loadChildren: () => import('./kirin/components/dashboard/dashboard.module').then(m => m.DashboardModule) },
                    { path: 'clients', loadChildren: () => import('./kirin/components/clients/clients.module').then(m => m.ClientsModule) },
                    { path: 'contracts', loadChildren: () => import('./kirin/components/contracts/contracts.module').then(m => m.ContractsModule) },
                    { path: 'invoices', loadChildren: () => import('./kirin/components/invoices/invoices.module').then(m => m.InvoicesModule) },
                    { path: 'dockets', loadChildren: () => import('./kirin/components/dockets/dockets.module').then(m => m.DocketsModule) },
                    { path: 'users', loadChildren: () => import('./kirin/components/users/users.module').then(m => m.UsersModule) },
                   
                   /* { path: 'uikit', loadChildren: () => import('./demo/components/uikit/uikit.module').then(m => m.UIkitModule) },
                    { path: 'utilities', loadChildren: () => import('./demo/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
                    { path: 'documentation', loadChildren: () => import('./demo/components/documentation/documentation.module').then(m => m.DocumentationModule) },
                    { path: 'blocks', loadChildren: () => import('./demo/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
                    { path: 'pages', loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) }*/
                ]
            },
            { path: 'auth', loadChildren: () => import('./kirin/components/auth/auth.module').then(m => m.AuthModule) },
            //{ path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
            { path: 'notfound', component: NotfoundComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
